import { E_KEYWORD } from "../enums/Keywords";
import { ERequestMethods } from "../enums/RequestMethod";
import { request } from "../libs/request";
import { ICreateOrUpdateKeyword, IKeyword } from "../types/Keyword";
import { IResponseData, ListResponseData } from "../types/requests";


function getKeywords() {
  return request<ListResponseData<IKeyword>>({
    method: ERequestMethods.GET,
    url: E_KEYWORD.MAIN,
  });
}

function createOrUpdateKeywords(data: ICreateOrUpdateKeyword) {
  return request<IResponseData<IKeyword[]>>({
    method: ERequestMethods.POST,
    url: E_KEYWORD.CREATE_OR_UPDATE,
    data,
  });
}

const KeywordRepository = Object.freeze({
  createOrUpdateKeywords,
  getKeywords,
});

export default KeywordRepository;
